import {Stack} from '@chakra-ui/react';
import type {GroupBase, MultiValueGenericProps} from 'chakra-react-select';

export const MultiValueContainer = <
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  children,
  innerProps,
}: MultiValueGenericProps<Option, IsMulti, Group>) => {
  return (
    <Stack {...innerProps} spacing={1} direction={`row`}>
      {children}
    </Stack>
  );
};
